module.exports = __webpack_public_path__ + "img/SitecoreTeaser350x174RIC3Mesi20190918.c77d4e66.jpg";